import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants'

export default (theme: APTheme) => createStyles({
    root: {
        marginRight: 20,
    },
    formControl: {
        position: 'relative',
        '& .MuiSvgIcon-root': {
            fontSize: '2.4rem'
        },
        '& .MuiInputBase-input': {
            backgroundColor: '#ffffff', // TODO - Get hex colour codes from constant style variables
            height: '1.125em',
            fontSize: 20
        },
        '& .MuiInputBase-root': {
            height: 45,
            marginRight: 15
        },
        '& .MuiInputBase-input.Mui-disabled': {
            color: '#4a4a4a', // TODO - Get hex colour codes from constant style variables
            backgroundColor: '#f5f5f5' // TODO - Get hex colour codes from constant style variables
        },
        '& .MuiInput-underline:before, & .MuiInput-underline:after': {
            borderBottom: `2px solid ${theme.palette.primary.main}`,
            top: 63,
            '@media(max-width: 768px)': {
                top: 55
            }
        },
        '& .MuiInputAdornment-positionStart': {
            marginRight: 20,
            '@media(max-width: 480px)': {
                marginRight: 5
            }
        },
        '& .MuiIconButton-root': {
            padding: '0px 12px'
        },
        width: '100%'
    },
    searchIcon: {
        width: 23.64,
        height: 23.64
    }
});